<template>
  <div class="administrators-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-input placeholder="请输入管理员账号" clearable v-model="param.manager" size="small" @keyup.enter.native="getAdmList('status')" class="param-input"></el-input>
      <el-input placeholder="请输入操作位置" clearable v-model="param.position" size="small" @keyup.enter.native="getAdmList('status')" class="param-input"></el-input>
      <el-input placeholder="请输入uri" clearable v-model="param.uri" size="small" @keyup.enter.native="getAdmList('status')" class="param-input"></el-input>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
      <el-button type="primary" size="small" @click="getCtrLog('status')">搜索</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="manager" label="管理员账号" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.manager || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="position" label="操作位置" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.position || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作动作" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.operator || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="操作内容" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.content || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uri" label="操作URI" align="center" width="260">
        <template slot-scope="scope">
          <span>{{scope.row.uri || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="操作时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.remarks || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button type="success" class="el-icon-edit" size="mini" @click="adminOperation('edit',scope.row)"></el-button>
          <!-- <el-button type="danger" class="el-icon-delete" size="mini" @click="removeAdmin(scope.row.id)"></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="param.pageNumber" :page-size="param.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 编辑弹窗 -->
    <edit-log ref="editLog" @handlerCtrLog="getCtrLog"></edit-log>
  </div>
</template>
<script>
import api from '@/api'
import { changeTime } from '@/utils/global'
import EditLog from './components/editLog'
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      time: '',
      param: {
        manager: '',
        position: '',
        uri: '',
        start: '',
        end: '',
        pageNumber: 1,
        pageSize: 10
      }
    }
  },
  components: {
    EditLog
  },
  created() {
    this.getCtrLog()
  },
  methods: {
    // 请求操作日志
    getCtrLog(type) {
      if (type) {
        this.param.pageNumber = 1
      }
      this.loading = true
      api.getAdminLog(this.param).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.tip);
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 打开编辑弹窗
    adminOperation(type,data) {
      this.$refs.editLog.open(type,data)
    },
    // 当前页发生变化
    changeCurrent(number) {
      this.param.pageNumber = number;
      this.getCtrLog()
    },
    // 当前页条数发生变化
    changeSize(size) {
      this.param.pageSize = size;
      this.param.pageNumber = 1;
      this.getCtrLog()
    },
    // 时间变化
    changeTime(time) {
      if (time) {
        this.param.start = changeTime(time[0])
        this.param.end = changeTime(time[1])
      } else {
        this.param.start = ''
        this.param.end = ''
      }
      this.getCtrLog()
    }
  }
}
</script>